import React, { ChangeEvent, useEffect, useState } from "react";
import { PageTitle } from "../../../../_metronic/layout/core";
import { Button, Form, Modal, Row } from "react-bootstrap";
import { KTSVG } from "../../../../_metronic/helpers";
import { useAuth } from "../../../modules/auth";

const API_URL = process.env.REACT_APP_API_URL

const AnalisisContexto: React.FC = () => {
    const [showModal, setShowModal] = useState<boolean>();
    const [nombre, setNombre] = useState<string>();
    const auth = useAuth();

    const openModal = async () => {
        setShowModal(true)
    }

    const closeModal = async () => {
        setShowModal(false)
    }

    const onChangeNombre = async (nomb:string) => {
        setNombre(nomb)
    }

    const addCategoria =async () => {
        
    }

    const getEtiquetas =async () => {
        try {
            const response = await fetch(`${API_URL}/etiqueta/getAnalisisContexto`, {
              headers: {
                'Content-Type': 'application/json',
                'auth-token': auth.auth?.api_token!,
              }
            });
            if (!response.ok) {
              throw Error(response.statusText);
            }
            const data = await response.json();
            console.log(data)
          } catch (err) {
            console.log(err);
          };
    }

    useEffect(() => {
        getEtiquetas()
    })

    return (
        <>
            <PageTitle>Catálogo de Etiquetas</PageTitle>
            <Row>
                <Button className="btn-primary" onClick={openModal}>Nueva categoría</Button>
            </Row>
            <Row>
                <table className='table table-hover table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead>
                        <tr>
                            <th>&nbsp;</th>
                            <th className="w-50"><h3>Clasificación</h3></th>
                            <th className="w-50"><h3>Etiquetas</h3></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><span className="badge badge-success">+</span></td>
                            <td>Clasificacion1</td>
                            <td>
                                <table className="table">
                                    <tbody>
                                    <tr><td>Etiqueta 1</td></tr>
                                    <tr><td>Etiqueta 1</td></tr>
                                    <tr><td>Etiqueta 1</td></tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td><span className="badge badge-success">+</span></td>
                        </tr>
                    </tbody>
                </table>
            </Row>
            <Modal show={showModal} onHide={closeModal} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Agregar nueva categoría</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="nombre">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control onChange={(e) => {onChangeNombre(e.target.value)}} type="text" placeholder="Escribe el nombre de la categoría" />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn btn-danger" onClick={closeModal}>Cancelar</Button><Button>Guardar</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export { AnalisisContexto };